export default "__VITE_ASSET__BsUaxtOL__"